// extracted by mini-css-extract-plugin
module.exports = {"card":"cardContainer-module--card--Mj6FZ"};